"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merge = _interopRequireDefault(require("./merge"));
function compose() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }
  const fn = props => styles.reduce((acc, style) => {
    const output = style(props);
    if (output) {
      return (0, _merge.default)(acc, output);
    }
    return acc;
  }, {});
  fn.filterProps = styles.reduce((acc, style) => acc.concat(style.filterProps || []), []);
  return fn;
}
var _default = exports.default = compose;